import { useCallback, useEffect, useState } from "react";
import { Button, Modal, Pagination, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import useAxiosPrivate from "../../../Pages/hooks/useAxiosPrivate";
import { baseURL } from "../../../API/API";
import { toast } from "react-toastify";
import "./Content.css";
import { getCoursePackageTypeLabel } from "../../../utils/packageLabels";

export default function CoursePackagesDashboard() {
  const axiosPrivate = useAxiosPrivate();
  const [packages, setPackages] = useState([]);
  const [indexpage, setIndexPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [deleteId, setDeleteId] = useState(null);

  const fetchPackages = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axiosPrivate.get(`${baseURL}/learning/packages/all-admin?indexpage=${indexpage}`);
      setPackages(Array.isArray(res.data?.data) ? res.data.data : []);
      setTotalPages(res.data?.last_page || res.data?.totalPages || 1);
    } catch (err) {
      toast.error(err.response?.data?.message || "فشل تحميل باقات الترم والسنة");
    } finally {
      setLoading(false);
    }
  }, [axiosPrivate, indexpage]);

  useEffect(() => {
    fetchPackages();
  }, [fetchPackages]);

  const handleDelete = async () => {
    try {
      await axiosPrivate.delete(`${baseURL}/learning/packages/delete/${deleteId}`);
      toast.success("تم حذف الباقة بنجاح");
      setDeleteId(null);
      fetchPackages();
    } catch (err) {
      toast.error(err.response?.data?.message || "فشل حذف الباقة");
    }
  };

  return (
    <div className="p-4 content" dir="rtl">
      <div className="d-flex align-items-center justify-content-between mb-5 flex-wrap gap-3">
        <h4 className="fw-bold m-0">باقات الترم والسنة الكاملة</h4>
        <Link to="/DashboardLayout/packages/add">
          <Button className="custom-brand-btn-dhash d-flex align-items-center gap-2 px-4">
            <FontAwesomeIcon icon={faPlus} />
            <span>إضافة باقة</span>
          </Button>
        </Link>
      </div>

      <div className="table-responsive">
        {loading ? (
          <div className="text-center py-5 text-muted">جاري التحميل...</div>
        ) : packages.length === 0 ? (
          <div className="text-center py-5 text-muted">لا توجد باقات ترم أو سنة مضافة حاليا.</div>
        ) : (
          <Table striped bordered hover className="align-middle text-center">
            <thead style={{ backgroundColor: "var(--brand-200)", color: "#fff" }}>
              <tr>
                <th>الاسم</th>
                <th>النوع</th>
                <th>السنة الدراسية</th>
                <th>المدرس</th>
                <th>السعر</th>
                <th>الخصم</th>
                <th>الشهور</th>
                <th>الحالة</th>
                <th>أدوات</th>
              </tr>
            </thead>
            <tbody>
              {packages.map((row) => (
                <tr key={row.id}>
                  <td className="fw-bold">{row.name}</td>
                  <td>{getCoursePackageTypeLabel(row)}</td>
                  <td>{row.academic_year_name || "-"}</td>
                  <td>{row.teacher_name || "-"}</td>
                  <td>{row.price} ج.م</td>
                  <td>{row.discount} ج.م</td>
                  <td><span className="badge bg-purple-light text-purple">{row.chapters_count} شهر</span></td>
                  <td>{row.is_draft ? <span className="badge bg-warning-light text-warning">مسودة</span> : <span className="badge bg-success-light text-success">منشورة</span>}</td>
                  <td>
                    <div className="d-flex justify-content-center gap-2">
                      <Link to={`/DashboardLayout/packages/update/${row.id}`}>
                        <Button size="sm" variant="outline-info"><FontAwesomeIcon icon={faPen} /></Button>
                      </Link>
                      <Button size="sm" variant="outline-danger" onClick={() => setDeleteId(row.id)}><FontAwesomeIcon icon={faTrash} /></Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </div>

      {totalPages > 1 && (
        <div className="d-flex justify-content-center mt-4" dir="ltr">
          <Pagination>
            {[...Array(totalPages)].map((_, i) => (
              <Pagination.Item key={i + 1} active={i + 1 === indexpage} onClick={() => setIndexPage(i + 1)}>{i + 1}</Pagination.Item>
            ))}
          </Pagination>
        </div>
      )}

      <Modal show={Boolean(deleteId)} onHide={() => setDeleteId(null)} centered dir="rtl">
        <Modal.Body className="text-center py-4">
          <p className="fs-5 fw-bold mb-4">هل أنت متأكد من حذف هذه الباقة؟</p>
          <div className="d-flex justify-content-center gap-3">
            <Button variant="danger" onClick={handleDelete}>نعم، احذف</Button>
            <Button variant="secondary" onClick={() => setDeleteId(null)}>إلغاء</Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}